module.exports = __webpack_public_path__ + "mer/img/iconfont.e9f41a95.svg";